module.exports = __webpack_public_path__ + "static/media/pic@3x.fcf0a05d.png";